// 工作人员确认 两融专员确认
// propData: { title: "", messageText: "" }
<template>
  <div class="cancel-credit-check-box">
    <!-- <div class="cancel-credit-check-title">{{  }}</div> -->
    <check-list :checkList="propData.listData" :hideSubtitle="propData.hideSubtitle" :title="propData.title" v-if="propData.showPreCheckList"></check-list>
  </div>
</template>

<script>

import checkList from "./checklist";
export default {
  components: {
    checkList
  },
  props: {
    propData: {
      type: Object,
      default: {
        title: "销户检查结果",
        showPreCheckList: true,
        listData: [],//检查元素 {
        //RESTRICT_TYPE: "1" //0拒绝办理业务，1禁止办理,2警告，3提示,
        //HANDLE_TIP:"我是提示语",
        //"MENU_ID":"我是点击跳转的菜单ID",
        // MENU_NAME: "我是菜单名称",
        // BUSI_CODE_ACS: "V0012",//业务代码}
      }
    }
  },
  data () {
    return {};
  },
  created () {

  }
};
</script>
<style lang="less" scoped>
.cancel-credit-check-box {
  width: 1300px;
  height: 100%;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/cancelCreditCheck.vue